__webpack_require__.p = "/facts-generator/";